import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchWallet } from "services/api/wallet";
import { AuthState } from "slices/auth/reducer";
import { Wallet, WalletState } from "types/wallet";
import { isFresh } from "utils/helpers";

export const fetchWalletThunk = createAsyncThunk<{ wallet: Wallet, cached?: boolean }, { force?: boolean }, { rejectValue: string }>(
    'wallet/fetch',
    async ({ force = false }, { getState, rejectWithValue }) => {
        const state = getState() as { walletState: WalletState, auth: AuthState };
        const selectedAgencyId = state.auth.selectedAgencyId;
        const staleTime = apiConfig.FETCH_WALLET.staleTime || 0;
        try {
            if (!selectedAgencyId) {
                return rejectWithValue('No agency selected');
            }

            const currentWalletData = state.walletState.wallet;
            if (!force && currentWalletData && isFresh(state.walletState.last_fetched, staleTime) && !state.walletState.expired) {
                return { wallet: currentWalletData, cached: true };
            }

            const wallet = await fetchWallet(selectedAgencyId);
            return { wallet };
        } catch (error) {
            return rejectWithValue('Failed to fetch wallet data');
        }
    });